var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOnlineBookingSolid = function SvgOnlineBookingSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 5H5c-.667 0-2 .4-2 2v12c0 .667.4 2 2 2h8l-2-7c-1-2.5.5-4 3.5-3l4.5 1.5V7c0-.667-.4-2-2-2h-1.25v1.5a.75.75 0 0 1-1.5 0V5h-6.5v1.5a.75.75 0 0 1-1.5 0V5Zm-2 4A.75.75 0 0 1 5 8.25h12a.75.75 0 0 1 0 1.5H5A.75.75 0 0 1 4.25 9Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 21H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m13 13 9 3-4 2-2 4-3-9ZM15 3v2M7 3v2",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgOnlineBookingSolid;